export default __webpack_public_path__ + "static/media/circle-logo.11963c65.svg";